import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    photoStrageLimit: PropTypes.number.isRequired,
    allFileCapacity: PropTypes.number.isRequired,
    albumFileCapacity: PropTypes.number,
  },
  render() {
    var thisAlbumCapacityPercentage = this.props.albumFileCapacity
      ? (this.props.albumFileCapacity / this.props.photoStrageLimit) * 100
      : 0;
    var thisAlbumCapacity = this.props.albumFileCapacity
      ? this.props.albumFileCapacity
      : 0;
    var otherAlbumCapacityPercentage = this.props.allFileCapacity
      ? ((this.props.allFileCapacity - thisAlbumCapacity) /
          this.props.photoStrageLimit) *
        100
      : 0;

    var otherAlbumBarClass = "progress-bar progress-bar-info";
    var thisAlbumBarClass = "progress-bar progress-bar-warning";

    if (otherAlbumCapacityPercentage >= 100) {
      otherAlbumCapacityPercentage = 100;
      thisAlbumCapacityPercentage = 0;
      otherAlbumBarClass = "progress-bar progress-bar-danger";
    } else if (
      otherAlbumCapacityPercentage + thisAlbumCapacityPercentage >=
      100
    ) {
      thisAlbumCapacityPercentage = 100 - otherAlbumCapacityPercentage;
      thisAlbumBarClass = "progress-bar progress-bar-danger";
    }
    return (
      <div className="mt-4" style={{ padding: "0px" }}>
        <div
          className="col-md-5 offset-md-7 col-sm-5 offset-sm-7 col-xs-5 offset-xs-7"
          style={{ padding: "0px" }}
        >
          <div
            className="progress"
            style={{ borderRadius: "3px", margin: "0px", height: "10px" }}
          >
            <div
              className={otherAlbumBarClass}
              style={{
                width: otherAlbumCapacityPercentage + "%",
                borderRadius: "0 3px 3px 0",
                display: "block",
                float: "left",
                height: "10px",
              }}
            />
            <div
              className={thisAlbumBarClass}
              style={{
                width: thisAlbumCapacityPercentage + "%",
                borderRadius: "3px 0 0 3px",
                display: "block",
                float: "left",
                height: "10px",
              }}
            />
          </div>
          {/* 2026: 左詰めで「35MB / 100MB 使用中」 */}
          <p className="small">
            {this.props.allFileCapacity}MB / {this.props.photoStrageLimit}MB 使用中
          </p>
        </div>
        <div style={{ clear: "both" }} />
      </div>
    );
  },
});
